import { FC, useMemo } from 'react'
import Skeleton from 'react-loading-skeleton'
import clsx from 'clsx'

import Lectors from './lectors/lectors'
import ToggleTextButton from 'components/parts/toggle-text-button/toggle-text-button'
import BasicTag from 'components/tags/basic-tag/basic-tag'
import SubscribersGet from 'components/parts/subscribers-get/subscribers-get'
import TagThemes from 'components/tags/basic-tag/themes'
import CardSpeciality from 'components/cards/card-parts/card-speciality/card-speciality'
import usePCWindow from 'hooks/usePCWindow'

import { ScreenSize } from 'constants/media-constanst'
import { formatMoscowDate } from 'utils/formatDate'
import { highlightText } from 'utils/search/hightlightText'
import { IWebinarCard } from 'constants/types/card.types'
import { A_wf_clickSubscription, A_wf_openWebinar } from 'utils/analytics/webinars/webinar_future'

import styles from './new-webinar-card.module.scss'

const NewWebinarCard: FC<IWebinarCard> = ({
  id,
  activeNMOCodes,
  name,
  startDate,
  Lecturs,
  Specialities,
  lecturName,
  isFullInfo,
  isLoaded,
  handleToggle,
  isSubscribed,
  cardModificator,
  cutQueryWords,
  cardBottomModificator,
  btnModificator,
  noBorderRadius,
  AData,
}: IWebinarCard) => {
  const formatedDate: any = useMemo(
    () => (startDate ? formatMoscowDate(startDate as Date) : {}),
    [startDate]
  )

  const hightlightedTitle = highlightText(cutQueryWords, name)
  const isMobile = usePCWindow(ScreenSize.mobile)

  const subAnalytics = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    if (AData && AData.originSub) A_wf_clickSubscription(AData.originSub, id)
  }

  const clickAnalytics = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    if (AData && AData.originClick) A_wf_openWebinar(AData.originClick, id)
  }

  return (
    <div
      className={clsx(styles.card, {
        [cardModificator as string]: cardModificator,
        [styles.noBorderRadius]: isFullInfo || noBorderRadius,
      })}
      onClick={clickAnalytics}
    >
      <div>
        <div className={styles.headerWrap}>
          <div className={styles.header}>
            {isLoaded ? (
              <BasicTag uppercase={false}>
                {`${formatedDate.date} ${formatedDate.monthName}, ${formatedDate.time} МСК`}
              </BasicTag>
            ) : (
              <Skeleton width={190} height={31} />
            )}
            {activeNMOCodes && isMobile && <BasicTag themeColor={TagThemes.YELLOW}>НМО</BasicTag>}
          </div>
          <div className={styles.headerRight}>
            {!isMobile && activeNMOCodes && <BasicTag themeColor={TagThemes.YELLOW}>НМО</BasicTag>}
          </div>
        </div>
        <p className={styles.title}>{isLoaded ? hightlightedTitle : <Skeleton count={2} />}</p>
        {isFullInfo && (
          <div className={styles.lectur}>
            <Lectors Lecturs={Lecturs} lecturName={lecturName} />
          </div>
        )}
      </div>
      <div>
        <div
          className={clsx(styles.bottom, {
            [cardBottomModificator as string]: cardBottomModificator,
          })}
        >
          {isFullInfo && (
            <div className={styles.bottomInfo}>
              {Specialities && (
                <div className={styles.speciality}>
                  <CardSpeciality Specialities={Specialities} />
                </div>
              )}
              <SubscribersGet id={id} text="чел. уже идут" />
            </div>
          )}
          <div
            className={clsx(styles.bottomRightPart, {
              [styles.isFullInfo]: isFullInfo,
            })}
          >
            <div
              className={clsx(styles.btnWrapper, {
                [btnModificator as string]: btnModificator,
              })}
              onClick={subAnalytics}
            >
              <ToggleTextButton
                onClick={handleToggle}
                isActive={isSubscribed}
                onlyPrimaryStatus={false}
                primaryText="Хочу смотреть"
                noIcon={false}
                secondaryTextOn="Вы подписаны"
                secondaryTextOff="Отписаться"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewWebinarCard
